// extracted by mini-css-extract-plugin
export default {"orders":"orders_orders__5VLFZ","header":"orders_header__ltekJ","filters":"orders_filters__68SLT","field":"orders_field__eHvES"};